"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  SingleManIdCard: ['single-man-id-card', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.75,3.75H5.25a1.5,1.5,0,0,0-1.5,1.5v16.5a1.5,1.5,0,0,0,1.5,1.5h13.5a1.5,1.5,0,0,0,1.5-1.5V5.25a1.5,1.5,0,0,0-1.5-1.5h-4.5', 'M14.25,3a2.25,2.25,0,0,0-4.5,0V6a.75.75,0,0,0,.75.75h3A.75.75,0,0,0,14.25,6Z', 'M8.625 13.125 A3.375 3.375 0 1 0 15.375 13.125 A3.375 3.375 0 1 0 8.625 13.125 Z', 'M18,23.25a6.054,6.054,0,0,0-12,0', 'M15.365,12.864a6.763,6.763,0,0,1-6.3-1.4']],
  SingleMan: ['single-man', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M7.476,3.334A8.711,8.711,0,0,0,13.75,6,8.725,8.725,0,0,0,17.2,5.29', 'M6.750 6.000 A5.250 5.250 0 1 0 17.250 6.000 A5.250 5.250 0 1 0 6.750 6.000 Z', 'M2.25,23.25a9.75,9.75,0,0,1,19.5,0']],
  SingleManCircle: ['single-man-circle', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M7.476,7.084A8.711,8.711,0,0,0,13.75,9.75,8.725,8.725,0,0,0,17.2,9.04', 'M6.750 9.750 A5.250 5.250 0 1 0 17.250 9.750 A5.250 5.250 0 1 0 6.750 9.750 Z', 'M18.913,20.876a9.746,9.746,0,0,0-13.826,0', 'M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z']],
  SingleManHome: ['single-man-home', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25 23.25L23.25 12 12 0.75 0.75 12 0.75 23.25', 'M8.643,11a6.476,6.476,0,0,0,7.218,1.451', 'M8.104 12.979 A3.896 3.896 0 1 0 15.896 12.979 A3.896 3.896 0 1 0 8.104 12.979 Z', 'M18.375,23.25a6.577,6.577,0,0,0-12.75,0']],
  SingleManBook: ['single-man-book', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21,23.25H5.25A2.25,2.25,0,0,1,3,21', 'M6,.75a3,3,0,0,0-3,3V21a2.25,2.25,0,0,1,2.25-2.25H19.5a1.5,1.5,0,0,0,1.5-1.5v-15A1.5,1.5,0,0,0,19.5.75Z', 'M19.5 23.25L19.5 18.75', 'M8.275 7.875 A3.375 3.375 0 1 0 15.025 7.875 A3.375 3.375 0 1 0 8.275 7.875 Z', 'M16.4,15a6.026,6.026,0,0,0-9.5,0', 'M15.023,7.987a6.77,6.77,0,0,1-1.873.263A6.727,6.727,0,0,1,8.582,6.47']],
  SingleManPodium: ['single-man-podium', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.5 15.75L19.5 15.75', 'M15.75 23.25L8.25 23.25 7.5 15.75 16.5 15.75 15.75 23.25z', 'M9.000 3.750 A3.000 3.000 0 1 0 15.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 Z', 'M12 8.25L12 12.75', 'M16.5,12.75a4.5,4.5,0,0,0-9,0']],
  SingleManSearch: ['single-man-search', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 10.500 A9.750 9.750 0 1 0 20.250 10.500 A9.750 9.750 0 1 0 0.750 10.500 Z', 'M17.394 17.394L23.25 23.25', 'M7.303 8.072 A3.198 3.198 0 1 0 13.699 8.072 A3.198 3.198 0 1 0 7.303 8.072 Z', 'M15,14.823a5.709,5.709,0,0,0-9,0', 'M13.7,8.178a6.425,6.425,0,0,1-1.776.25A6.371,6.371,0,0,1,7.6,6.741']],
  SingleManMonitor: ['single-man-monitor', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.500 2.250 L22.500 2.250 L22.500 18.750 L1.500 18.750 Z', 'M12 18.75L12 21.75', 'M4.5 21.75L19.5 21.75', 'M8.762 8.625 A3.375 3.375 0 1 0 15.512 8.625 A3.375 3.375 0 1 0 8.762 8.625 Z', 'M16.887,15.749a6.027,6.027,0,0,0-9.5,0', 'M15.512,8.736A6.76,6.76,0,0,1,9.069,7.219']],
  SingleManNews: ['single-man-news', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.500 2.250 L22.500 2.250 L22.500 18.750 L1.500 18.750 Z', 'M12 18.75L12 21.75', 'M4.5 21.75L19.5 21.75', 'M4.5 5.25H9V9.75H4.5z', 'M11.875 8.625 A3.375 3.375 0 1 0 18.625 8.625 A3.375 3.375 0 1 0 11.875 8.625 Z', 'M20,15.749a6.026,6.026,0,0,0-9.5,0', 'M18.625,8.736A6.752,6.752,0,0,1,16.75,9a6.723,6.723,0,0,1-4.568-1.781']],
  SingleManFocus: ['single-man-focus', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M8.445,6.531a6.858,6.858,0,0,0,7.643,1.536', 'M7.875 8.625 A4.125 4.125 0 1 0 16.125 8.625 A4.125 4.125 0 1 0 7.875 8.625 Z', 'M.75,6.751V2.25A1.5,1.5,0,0,1,2.25.75h4.5', 'M23.25,6.751V2.25a1.5,1.5,0,0,0-1.5-1.5h-4.5', 'M.75,17.25v4.5a1.5,1.5,0,0,0,1.5,1.5h4.5', 'M23.25,17.25v4.5a1.5,1.5,0,0,1-1.5,1.5h-4.5', 'M18.337,18.75a6.712,6.712,0,0,0-12.674,0']],
  SingleManProfilePicture: ['single-man-profile-picture', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.250 0.750 L21.750 0.750 L21.750 23.250 L2.250 23.250 Z', 'M8.471,7.009a6.83,6.83,0,0,0,7.6,1.518', 'M7.890 9.083 A4.110 4.110 0 1 0 16.110 9.083 A4.110 4.110 0 1 0 7.890 9.083 Z', 'M18.75,19.027a7.63,7.63,0,0,0-13.5,0']],
  SingleManPhoneBook: ['single-man-phone-book', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.387 9.523 A3.109 3.109 0 1 0 15.605 9.523 A3.109 3.109 0 1 0 9.387 9.523 Z', 'M16.871,16.085a5.552,5.552,0,0,0-8.75,0', 'M15.605,9.626a6.234,6.234,0,0,1-1.727.243A6.2,6.2,0,0,1,9.67,8.229', 'M5.25 0.75L5.25 23.25', 'M23.25 3L23.25 6', 'M23.25 9L23.25 12', 'M23.25 15L23.25 18', 'M0.750 0.750 L20.250 0.750 L20.250 23.250 L0.750 23.250 Z']],
  SingleManShield: ['single-man-shield', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25,9.937A13.5,13.5,0,0,1,12,23.25,13.5,13.5,0,0,1,.75,9.937V2.25A1.5,1.5,0,0,1,2.25.75h19.5a1.5,1.5,0,0,1,1.5,1.5Z', 'M8.625 8.625 A3.375 3.375 0 1 0 15.375 8.625 A3.375 3.375 0 1 0 8.625 8.625 Z', 'M17.387,16.75a6.032,6.032,0,0,0-10.774,0', 'M15.375,8.736A6.76,6.76,0,0,1,8.932,7.219']],
  SingleManVintageTv: ['single-man-vintage-tv', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 2.250 L23.250 2.250 L23.250 18.750 L0.750 18.750 Z', 'M15.75 2.25L15.75 18.75', 'M18.75 11.25L20.25 11.25', 'M18.75 14.25L20.25 14.25', 'M19.5,7.5a.375.375,0,1,0,.375.375A.375.375,0,0,0,19.5,7.5', 'M2.25 21.75L5.25 18.75', 'M21.75 21.75L18.75 18.75', 'M5.052 8.723 A3.198 3.198 0 1 0 11.448 8.723 A3.198 3.198 0 1 0 5.052 8.723 Z', 'M12.75,15.473a5.71,5.71,0,0,0-9,0', 'M11.448,8.829a6.427,6.427,0,0,1-1.777.25A6.375,6.375,0,0,1,5.343,7.392']]
};
exports["default"] = _default;